export default {
  name: 'phoneNumber',
  filter: function (value) {
    if (!value) return ''
    value = value.toString()
    return value.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }
}
